import { useEffect } from "react";
import './App.css';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Service from './components/Service';
import CustomCursor from './components/CustomCursor'; 
import StatsSection from "./components/StatsSection";

function App() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when the page reloads
  }, []);

  return (
    <div className="App relative">
        <CustomCursor /> {/* Global Custom Cursor */}
        <Header/>
        <Hero />
        <About/>
        <Projects/>
        <Service/>
        <StatsSection/>
        <Contact/>
        <Footer/>
    </div>
  );
}

export default App;
